import Options from '../../Options.esm.js';

var regexMatcher = (match => {
  if (match.regexName === 'recentYear') {
    return {
      warning: Options.translations.warnings.recentYears,
      suggestions: [Options.translations.suggestions.recentYears, Options.translations.suggestions.associatedYears]
    };
  }

  return {
    warning: '',
    suggestions: []
  };
});

export { regexMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
